/** Les libellés HTML restent lisibles lorsque le graphique SVG se redimensionne. */
export function chartValueTicks(min: number, max: number, locale: string) {
  const span = max - min;
  const tinyScale = span < 0.0001;
  const precision = Math.min(20, Math.max(2, Math.ceil(-Math.log10(span / 4)) + 1));
  const formatter = new Intl.NumberFormat(locale, tinyScale
    ? { notation: 'scientific', maximumSignificantDigits: 5 }
    : { notation: span >= 1000 ? 'compact' : 'standard', maximumFractionDigits: precision });
  const ticks = [0, 0.25, 0.5, 0.75, 1].map((fraction) => ({ fraction, text: formatter.format(max - fraction * span) }));
  return { ticks, width: Math.max(48, ...ticks.map(({ text }) => [...text].length * 7 + 4)) };
}

export function ChartValueAxis({ ticks, top, bottom, height }: {
  ticks: { fraction: number; text: string }[]; top: number; bottom: number; height: number;
}) {
  return <div className="relative h-56 text-right text-[11px] leading-none text-slate-600" aria-hidden>
    {ticks.map(({ fraction, text }) => <span key={fraction} className="absolute inset-x-0 -translate-y-1/2 tabular-nums" style={{ top: `${(top + fraction * (height - top - bottom)) / height * 100}%` }}>{text}</span>)}
  </div>;
}
